import { APIClient } from "../helpers/api_helper";
import { ApiResponse } from "../types/api";

const api = new APIClient();

const resource = (token: string) =>
  `/public/appointment-reviews/${encodeURIComponent(token)}`;

export interface PublicAppointmentReviewPreview {
  tenant: { name: string };
  service: { name: string };
  professional: { name: string | null };
  unit: { name: string | null };
  scheduled_at: string | null;
  scheduled_label: string | null;
  already_submitted: boolean;
  google_review_url: string | null;
}

export interface PublicAppointmentReviewSubmitResult {
  already_submitted: boolean;
  rating: number;
  google_review_url: string | null;
}

export const getPublicAppointmentReview = (
  token: string
): Promise<ApiResponse<PublicAppointmentReviewPreview>> =>
  api.get<ApiResponse<PublicAppointmentReviewPreview>>(resource(token));

export const submitPublicAppointmentReview = (
  token: string,
  payload: { rating: number; comment?: string }
): Promise<ApiResponse<PublicAppointmentReviewSubmitResult>> =>
  api.create<ApiResponse<PublicAppointmentReviewSubmitResult>>(resource(token), payload);
